import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  actionOpenLaborTicketModal,
  actionOpenSetupActionModal,
} from 'lib/actions';
import { getUseSetupActionModal } from 'lib/selectors/getUseSetupActionModal';

/**
 * Returns a callback that starts the submit-work flow for the current labor
 * ticket context.
 *
 * Submit work opens the setup action modal in submit mode when
 * getUseSetupActionModal says so, and the standard submit modal otherwise.
 */
const useStartSubmitWork = () => {
  const dispatch = useDispatch();

  const useSetupActionModal = useSelector(getUseSetupActionModal);

  return useCallback(() => {
    if (useSetupActionModal) {
      return dispatch(actionOpenSetupActionModal('submit'));
    }
    return dispatch(actionOpenLaborTicketModal('submit'));
  }, [dispatch, useSetupActionModal]);
};

export default useStartSubmitWork;
